import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCogOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M10.565 2h2.87l1.714 2.57 2.791-.644 2.134 2.134-.644 2.791L22 10.565v2.87l-2.57 1.714.644 2.791-2.134 2.134-2.791-.644L13.435 22h-2.87L8.85 19.43l-2.791.644-2.134-2.134.644-2.791L2 13.435v-2.87L4.57 8.85 3.926 6.06 6.06 3.926l2.791.644L10.565 2Zm1.07 2L9.75 6.83 6.69 6.124l-.566.566.706 3.059L4 11.635v.73l2.83 1.886-.706 3.059.566.566 3.059-.706L11.635 20h.73l1.886-2.83 3.059.706.566-.566-.706-3.059L20 12.365v-.73L17.17 9.75l.706-3.059-.566-.566-3.059.706L12.365 4h-.73ZM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
		clipRule: "evenodd"
	})
});
export default SvgCogOutlined;
